// Name these functions the same as their corresponding path helpers in rails.
// Organize them under the "resource" that has the same name as their rails
// controller.
import { environment } from '../../../environments/environment';

export function backendDomain() {
  return environment.samplingBackendServiceBaseUrl;
}

export function portalDomain() {
  return environment.samplingPortalServiceBaseUrl;
}

export function samplingPortalPath(project: number) {
  return `${portalDomain()}/projects/${project}/quality`;
}

export function getSamplePath(projectId: number, sampleId: number) {
  return `${backendDomain()}/v1/projects/${projectId}/samples/${sampleId}`;
}

export function getLatestTaskScorePath(
  projectId: number,
  taskId: string,
  round: number,
) {
  return `${backendDomain()}/v1/projects/${projectId}/tasks/${taskId}/score/latest?round=${round}`;
}

export function updateTaskScorePath(
  projectId: number,
  taskId: string,
  round: number,
  context: string,
) {
  return `${backendDomain()}/v1/projects/${projectId}/tasks/${taskId}/score/round/${round}/context/${context}`;
}

export function getSampleTasksPath(projectId: number, sampleId: number) {
  return `${backendDomain()}/v1/projects/${projectId}/samples/${sampleId}/tasks?select=for_review`;
}

export function markTaskAsReviewedPath(
  projectId: number,
  sampleId: number,
  sampleTaskId: number,
) {
  return `${backendDomain()}/v1/projects/${projectId}/samples/${sampleId}/tasks/${sampleTaskId}/review`;
}

export function finalizeSamplePath(projectId: number, sampleId: number) {
  return `${backendDomain()}/v1/projects/${projectId}/samples/${sampleId}/finalize`;
}

export function sampleTaskFeedbackCountPath(
  projectId: number,
  sampleId: number,
) {
  return `${environment.annotationStoreServiceBaseUrl}/projects/${projectId}/samples/${sampleId}/tasks_feedback_count`;
}
